import {
  Badge,
  Box,
  Divider,
  HStack,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from '@elkaso-app/web-design';
import dayjs from 'dayjs';
import { ISupplierContact, ISupplierProfile } from '../utils/types';

interface OverviewTabProps {
  profile: ISupplierProfile;
  contacts: ISupplierContact[];
}

export const OverviewTab = ({ profile, contacts }: OverviewTabProps) => {
  const bgColor = useColorModeValue('gray.50', 'gray.700');

  const stats = [
    { label: 'Total Products', value: profile.totalProducts },
    { label: 'Total Orders', value: profile.totalOrders.toLocaleString() },
    { label: 'Min. Order Value (AED)', value: (profile.minimumOrder ?? profile.minimumOrderValue ?? 0).toLocaleString() },
    { label: 'Cut Off Time', value: profile.cutOffTime },
  ];

  return (
    <Box>
      <SimpleGrid columns={{ base: 2, md: 4 }} spacing={4} mb={8}>
        {stats.map((s) => (
          <Box key={s.label} p={4} bg={bgColor} borderRadius='md'>
            <Stat>
              <StatLabel fontSize='xs' color='gray.500'>
                {s.label}
              </StatLabel>
              <StatNumber fontSize='xl'>{s.value}</StatNumber>
            </Stat>
          </Box>
        ))}
      </SimpleGrid>

      <Divider mb={6} />

      <HStack mb={4}>
        <Text fontSize='lg' fontWeight='bold' color='gray.700'>
          Contacts
        </Text>
        <Badge colorScheme='blue' fontSize='sm'>
          {contacts.length}
        </Badge>
      </HStack>

      <Table variant='simple' size='sm'>
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Role</Th>
            <Th>Email</Th>
            <Th>Phone</Th>
            <Th>Primary</Th>
            <Th>Created At</Th>
          </Tr>
        </Thead>
        <Tbody>
          {contacts.map((c, i) => (
            <Tr key={i}>
              <Td fontWeight='medium'>{c.name}</Td>
              <Td textTransform='capitalize'>{c.role?.replace(/[-_]/g, ' ')}</Td>
              <Td>{c.email}</Td>
              <Td>{c.phone}</Td>
              <Td>{c.isPrimary && <Badge colorScheme='blue'>Primary</Badge>}</Td>
              <Td>{c.createdAt ? dayjs(c.createdAt).format('DD-MM-YYYY') : '---'}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};
